import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Select, Typography, message } from 'antd';
import { useConfigQuery } from '../../../queries/useConfig';
import axios from 'axios';
import { api } from '../../../config/api';

const { Option } = Select;

const ParametrosLocais = ({ handleCloseModal }) => {
  const accessToken = window.localStorage.getItem("accessToken");
  const { data: config, error, refetch } = useConfigQuery();
  const [suprimirCodigos, setSuprimirCodigos] = useState(config?.terminalComercial?.suprimirCodigos);
  const [isLoading, setIsLoading] = useState(false);

  const salvarParametrosLocais = async () => {
    setIsLoading(true);

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
 

    console.log(suprimirCodigos);
    let parametros = {
      pesquisaLivre: config?.terminalComercial.pesquisaLivre || false,
      gerenciaEstoque: config?.terminalComercial.gerenciaEstoque || false,
      venderZerado: config?.terminalComercial.venderZerado || false,
      atualizarProdutoNaVenda:config?.terminalComercial?.atualizarProdutoNaVenda || false,
      ncm:config?.terminalComercial?.ncm || '',
      suprimirCodigos:suprimirCodigos
    };

    const terminalComercial = {
      id: config?.idTerminalComercial,
      idRefTerminalFiscal: config?.idRefTerminalFiscal,
      nome: config?.nomeTerminalComercial,
      parametros: JSON.stringify(parametros),
      idLoja: config?.idLoja,
      tpAmb: config?.tpAmb,
    };

    try {
      const response = await axios.put(
        `${api.techfood}/v1/terminal-comercial/${config?.idTerminalComercial}`,
        terminalComercial,
        options
      );
      message.success('Dados atualizados com sucesso!');
      console.log(response.data);
      if (refetch) await refetch();
      handleCloseModal();
    } catch (error) {
      message.error('Erro ao atualizar os dados.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };




  return (
    <>
      <Row align="middle" style={{ marginBottom: 16 }}>
        <Col flex="auto">
          <Typography.Text strong style={{ fontSize: 18 }}>
            Parâmetros
          </Typography.Text>
        </Col>
      </Row>

      <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
        Código dos produtos
      </Typography.Text>
      <Select
        value={suprimirCodigos}
        onChange={setSuprimirCodigos}
        style={{ width: '100%' }}
        placeholder="Selecione"
      >
        <Option value={false}>Mostrar</Option>
        <Option value={true}>Suprimir</Option>
      </Select>

      <Button
        type="primary"
        onClick={salvarParametrosLocais}
        loading={isLoading}
        style={{
          marginTop: 24,
          backgroundColor: '#000',
          borderColor: '#000',
          width: '15%',
        }}
      >
        Salvar
      </Button>
    </>
  );
};

export default ParametrosLocais;
